export function getPublicAssetPath(relativePath: string): string {
  const base = import.meta.env.BASE_URL ?? '/';
  const prefix = base.endsWith('/') ? base : `${base}/`;
  const suffix = relativePath.replace(/^\/+/, '');
  return suffix ? `${prefix}${suffix}` : prefix;
}
